export const parseSubStationNames = (list = []) =>
  list
    .map((item) => (typeof item === "string" ? item : item.name).trim())
    .filter(Boolean)
    .filter((name, index, arr) => arr.indexOf(name) === index);

export const parseSubStations = (list = []) =>
  list
    .map((item) => ({ id: item.id ?? null, name: item.name.trim(), active: item.active ?? true, image_name: item.image_name || null }))
    .filter((item) => item.name)
    .filter((item, index, arr) => arr.findIndex((i) => i.name === item.name) === index);

export default { parseSubStationNames, parseSubStations };
